import { formatDate, sessionStorage, ajax, urlQuery } from './index'
import { v1 as uuidv1 } from 'uuid'

function saveCalItems(vals, goodsId) {
  goodsId = goodsId || urlQuery('goodsId')
  if(!goodsId) return;
  sessionStorage.set(`calculateVals-${goodsId}`, {
    SA: vals.SA,
    birthday: vals.birthday,
    gender: vals.gender,
    payFrequencyType: vals.payFrequencyType,
    paymentPeriod: vals.paymentPeriod,
    smoking: vals.smoking,
  })
}
function getCalItemsFromStorage(goodsId) {
  goodsId = goodsId || urlQuery('goodsId')
  if(!goodsId) return;
  return  sessionStorage.get(`calculateVals-${goodsId}`);
}

function removeCalItemsFromStorage(goodsId) {
  goodsId = goodsId || urlQuery('goodsId')
  if(!goodsId) return;
  return  sessionStorage.remove(`calculateVals-${goodsId}`);
}

export default {
  saveCalItems,
  getCalItemsFromStorage,
  removeCalItemsFromStorage,
  // keyMap: {// 因为个人信息返回的字段和投保因子的字段名不同，需要转换一下
  //   certiNo: 'certificateNumber',
  //   certiType: 'certificateType',
  //   emails: 'email',
  //   givenName: 'givenName',
  //   lastName: 'surname',
  //   phones: 'phoneNumber',
  //   phone: 'phoneNumber',
  //   smoke: 'smoking',
  //   height: 'insurantHeight',
  //   occupationCode: 'occupation',
  //   building: 'residentialFlat',
  //   street: 'residentialBuilding',
  //   district: 'residentialDistrict'
  // },
  handleLoad(params) {
    if (!params.loadSum && window.location.pathname.indexOf('/online-application') > -1) {
      params.loadSum = '0'
    }
  },
  trialPrice(params, callback) {
    const productListParams = sessionStorage.get(`productListParams-${params.goodsPlanId}`)
    params.optionalLiability = productListParams && JSON.parse(productListParams)
    if (!params.optionalLiability) {
      return
    }

    this.handleLoad(params)
    let price = 0
    ajax({
      // 調用保费试算接口
      url: '/calculate/premium',
      loading: true,
      data: params,
      notip: true
    }).then((res) => {
      if (res.success) {
        if (res.value) {
          price = res.value.calValue
        }
        callback && callback(price, res.value)
      }
    })
  },
  // sortFactors (arr) {
  //   arr.sort((item1, item2) => {
  //     return item1.orderNum > item2.orderNum ? 1 : -1
  //   })
  // },
  // requestTrialDatasource (params, callback) {
  //   let dataSource = []
  //   let data = {
  //     ...params,
  //     ...{
  //       goodPlanId: params.goodsPlanId,
  //       categoryEnum: 'PREMIUMFACTOR',
  //       topicEnum: 'TRIAL'
  //     }
  //   }
  //   ajax({
  //     url: '/calculate/factorsDynamic',
  //     data: data,
  //     loading: true
  //   }).then((res) => {
  //     if (res.success) {
  //       let data = res.value || {}
  //       dataSource = (data.planFactors && data.planFactors.factorsDetailResDTOList) || []
  //       this.sortFactors(dataSource)
  //     }
  //     callback && callback(dataSource)
  //   })
  // },
  // setTrialPriceParam (key, value, factorParams, callback) {
  //   console.log('trial param set:', key, value)
  //
  //   if (isDate(value)) {
  //     value = formatDate('yyyy-MM-dd', value) + ' 00:00:00'
  //   }
  //
  //   if (!factorParams) {
  //     return
  //   }
  //   if (key) {
  //     if (typeof key === 'string') {
  //       if (factorParams[key]) {
  //         if (isArray(value)) { // 如果就是要数组  这里要改一下
  //           value = value[0]
  //         }
  //         factorParams[key] = value
  //         callback && callback(factorParams)
  //       }
  //     } else if (typeof key === 'object') {
  //       let flag = false
  //       for (let tkey in key) {
  //         if (factorParams[tkey] && key[tkey]) {
  //           flag = true
  //           if (isDate(key[tkey])) {
  //             key[tkey] = formatDate('yyyy-MM-dd', key[tkey]) + ' 00:00:00'
  //           }
  //           if (isArray(key[tkey])) { // 如果就是要数组  这里要改一下
  //             factorParams[tkey] = key[tkey][0]
  //           } else {
  //             factorParams[tkey] = key[tkey]
  //           }
  //         }
  //       }
  //
  //       if (flag) {
  //         callback && callback(factorParams)
  //       }
  //     }
  //   } else {
  //     callback && callback()
  //   }
  // },
  //
  dealInitTrialFactors(factorList = [], callback) {
    const submitFactorParams = {}
    factorList.forEach((item, index) => {
      let initValue = item.show && item.show.defaultValue
      const displayType = item.show && Number(item.show.displayType)
      const selectTyps = [2, 3, 4]
      if (selectTyps.indexOf(displayType) > -1) {
        initValue = initValue || (item.values && item.values[0] && item.values[0].customizeValue)
      }
      if (initValue) {
        if (displayType === 5) {
          // 日期
          if (typeof initValue === 'string') {
            initValue = formatDate('yyyy-MM-dd', initValue) + ' 00:00:00'
          }
        }
        submitFactorParams[item.customizeCode] = initValue
      }
    })

    callback && callback(submitFactorParams)
  },
  getInitTrialFactors(goodsId) {
    let factors = getCalItemsFromStorage(goodsId)
    try {
      factors = JSON.parse(factors)
    } catch (err) {
      console.log(err)
    }
    return factors
  },
  // getAdultDate (date = new Date()) {
  //   const year = date.getFullYear()
  //   const adultYear = year - 18
  //   date.setFullYear(adultYear)
  //   return date
  // },
  // clearFactorsSession () {
  //   sessionStorage.remove('calculateVals')
  //   // sessionStorage.remove('informAnswer')
  // },
  setFactorsToSession(data, goodsId) {
    if (data) {
      const calculateVals = getCalItemsFromStorage(goodsId)
      let vals = {}
      try {
        vals = JSON.parse(calculateVals)
      } catch (err) {
        console.log(err)
      }
      saveCalItems({ ...vals, ...data })
      // sessionStorage.set('calculateVals', { ...vals, ...data })
    }
  },
  // setPayFrequencyFactorsToSession (data) {
  //   if (data) {
  //     const payFrequencyData = sessionStorage.get('payFrequencyData')
  //     let vals = {}
  //     if (payFrequencyData) {
  //       vals = JSON.parse(payFrequencyData) || {}
  //     }
  //     sessionStorage.set('payFrequencyData', { ...vals, ...data })
  //   }
  // },
  // getPayFrequencyFactors () {
  //   let factors = sessionStorage.get('payFrequencyData')
  //   if (factors) {
  //     factors = JSON.parse(factors)
  //   }
  //   return factors
  // },
  // getDefaultModule (arr = [], key = '') { // 获取default的对象
  //   if (arr.length && key) {
  //     const obj = arr.find((item) => {
  //       return item[key] === 'DEFAULT'
  //     })
  //     if (obj) {
  //       return obj
  //     } else {
  //       return arr[0]
  //     }
  //   } else {
  //     return {}
  //   }
  // },
  // resetControlValue (info, infoTemp, type, form) {
  //   /**
  //   * info, 动态的信息
  //   *  infoTemp ,初始的Info
  //   *  type， 1：投保人 2：被保人 3：受益人
  //   *  form
  //   */
  //   setTimeout(() => {
  //     const { setFieldsValue, getFieldsValue } = form
  //     const initFactors = this.getInitTrialFactors() || {}
  //
  //     let keycode
  //     let newKey
  //     let allObj = getFieldsValue()
  //     let isCancel = Object.keys(info).length === 0
  //     let value
  //     if (isCancel && type === 2) {
  //       info = infoTemp
  //     }
  //
  //     if (info) {
  //       for (let key in info) {
  //         newKey = this.keyMap[key] || key
  //         keycode = newKey + '_' + type + '_1_0'
  //         value = info[key]
  //         if (allObj.hasOwnProperty(keycode)) {
  //           if ((newKey === 'birthday' || newKey === 'passportExpiryDate') && value) { // 如果新加日期格式的字段，这里一定要再加个判断转换成moment格式
  //             value = moment(new Date(value.replace(/-/g, '/')))
  //           }
  //
  //           if (isCancel && type === 2) {
  //             value = undefined
  //           }
  //
  //           if (type === 1) {
  //             setFieldsValue({ [keycode]: value })
  //           } else {
  //             if (value === undefined) {
  //               setFieldsValue({ [keycode]: value })
  //             } else {
  //               if (!initFactors[keycode]) {
  //                 setFieldsValue({ [keycode]: value })
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }, 0)
  // },
  // resetInitData (userData) { // 兼容处理--因为字段不一致
  //   // 这地方，应该要和投保因子接口结合起来，如果该投保因子，没有配置这个属性，不应该把值赋过来
  //   if (!userData) {
  //     return userData
  //   }
  //   for (let key in userData) {
  //     if (userData[key]) { // 如果有值
  //       let insureKey = this.keyMap[key] || key // 这个是相当于 email || emails
  //       if (this.keyMap[key]) { // 如果说是certificateNumber等这5项
  //         userData[insureKey] = userData[key]
  //         if (typeof userData[insureKey] === 'object') {
  //           userData[insureKey] = userData[insureKey][insureKey]
  //         }
  //       }
  //       // 因为手机号，邮箱，地址竟然都是用不同的字段来判断是否是
  //       if (isArray(userData[key])) {
  //         // *TODO: 需要做两件事情， 1.取出Default的那个对象，设置value 2. 取出手机号的default的对象，设置联系方式类型的value
  //         let obj = {}
  //         if (insureKey === 'email') {
  //           obj = this.getDefaultModule(userData[key], 'emailType')
  //           userData[insureKey] = obj.emailDetail || obj.email || ''
  //         }
  //         if (insureKey === 'phoneNumber') {
  //           obj = this.getDefaultModule(userData[key], 'phoneCategory')
  //           userData[insureKey] = obj.phoneNo || ''
  //           userData['contactNo'] = obj.phoneNo || ''
  //         }
  //         if (key === 'addresses') { // 需要对地址进行下处理
  //           obj = this.getDefaultModule(userData[key], 'addressCategory')
  //           // if (obj) {
  //           //   userData.address = obj.address || ''
  //           // }
  //           if (obj) {
  //             userData.residentialFlat = obj.building || ''
  //             userData.residentialBuilding = obj.street || ''
  //             userData.residentialDistrict = obj.district || ''
  //             if (userData.hasSameAddress !== 'OTHER') {
  //               userData.correspondenceFlat = obj.building || ''
  //               userData.correspondenceBuilding = obj.street || ''
  //               userData.correspondenceDistrict = obj.district || ''
  //             }
  //           }
  //           console.log('userData', userData)
  //         }
  //
  //         if (key === 'certiInfo') { // 需要对证件信息
  //           let faceObj1 = getAttrObject(userData[key], 'certiType', 'PERMHKID')[0]
  //           let faceObj2 = getAttrObject(userData[key], 'certiType', 'NONPERMHKID')[0]
  //           let backObj = getAttrObject(userData[key], 'certiType', 'HUZHAO')[0]
  //           let selfObj = getAttrObject(userData[key], 'certiType', 'SELFIE')[0]
  //
  //           let obj = faceObj1 || faceObj2
  //           if (obj) {
  //             userData.certificateNumber = obj.certiNo || userData.certificateNumber
  //             userData.certificateType = obj.certiType || userData.certificateType
  //             userData.certiFaceUrl = obj.certiFaceUrl || userData.certiFaceUrl
  //           }
  //           if (backObj) { // certibackUrl
  //             userData.passportPhotoUrl = backObj.certiFaceUrl || userData.passportPhotoUrl
  //             userData.passportNo = backObj.certiNo || userData.passportNo
  //             userData.passportExpiryDate = backObj.passportExpiryDate || backObj.passportExpiredDate || backObj.expiryDate || userData.passportExpiryDate
  //           }
  //           if (selfObj) {
  //             userData.selfie = selfObj.certiFaceUrl || userData.selfie
  //           }
  //         }
  //       }
  //     }
  //   }
  //
  //   return userData
  // },
  // getBirthdayErrorMsg (insurantBirthday, birthdayFactor) {
  //   let birthdayErrorMsg = ''
  //   let { minValue, maxValue } = birthdayFactor
  //  // insurantBirthday = transDateFormat(insurantBirthday)
  //   if (minValue && maxValue && insurantBirthday) {
  //     if (moment(maxValue).isBefore(moment(insurantBirthday))) {
  //       birthdayErrorMsg = template(Lang.anan_resp_insure_birthday_minmium_tip || 'Sorry, the minimum issue age is {XX}.', {
  //         XX: moment().year() - moment(maxValue).year()
  //       })
  //     }
  //     if (moment(minValue).isAfter(moment(insurantBirthday))) {
  //       birthdayErrorMsg = template(Lang.anan_resp_insure_birthday_maxmium_tip || `Sorry, the maximum issue age is {XX}.`, {
  //         XX: moment().year() - moment(minValue).year() - 1
  //       })
  //     }
  //   }
  //   console.log('birthdayErrorMsg',birthdayErrorMsg)
  //   return birthdayErrorMsg
  // },
  // checkInsureBirthday (birthday,blockData) { // birthday当前的出生日期，blockData是因子的数组集合
  //   const birthdayObj = getAttrObject(blockData, 'customizeCode', 'birthday')[0] || {}
  //   let birthdayErrorMsg = this.getBirthdayErrorMsg(birthday, birthdayObj.show || {})
  //   if (birthdayErrorMsg) {
  //     return true
  //   } else {
  //     return false
  //   }
  // },
  async isInHk() {
    const uuid = uuidv1()
    window.sessionStorage.setItem('ip_check_no', uuid)
    const rs = await ajax({
      url: '/common/ip/location',
      data: {
        checkNo: uuid
      }
    })
    return rs?.value?.city === '香港特别行政区'
  }
}
